var map = {
	"./educational-recources.jpg": 23,
	"./global-reach.jpg": 619,
	"./governance.jpg": 592,
	"./hero.jpg": 864,
	"./history.jpg": 518,
	"./innovative-education.jpg": 548,
	"./islamic-pedagogy.jpg": 521,
	"./leadership.jpg": 669,
	"./library.jpg": 383,
	"./professional-development.jpg": 49,
	"./quran.jpg": 487,
	"./student-learning.jpg": 556
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 962;